import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import {
  ApolloClientKey,
  useApolloClientsContext,
} from '../../providers/ApolloClientsProvider';

export const useIntegratedClient = (
  key: ApolloClientKey,
): ApolloClient<NormalizedCacheObject> => {
  const { clients } = useApolloClientsContext();

  const client = clients[key];
  if (client) return client;

  throw new Error(
    `The Apollo client with key ${key} is not set, make sure it's configured correctly`,
  );
};
